module.exports = __webpack_public_path__ + "static/media/img-msg-hurry-up@2x.c4b12c3a.png";